module.exports = __webpack_public_path__ + "open-iconic.3cf97837524dd7445e9d.woff";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/assets/open-iconic-master/font/fonts/open-iconic.woff
// module id = ../../../../../src/assets/open-iconic-master/font/fonts/open-iconic.woff
// module chunks = styles